<template>
  <span class="elementContainer">
       <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
       <div class="row form-group">
          <!--<div class="col col-md-3"><label class=" form-control-label">{{ $t('selproduct.parent_id') }}</label></div>-->
          <div class="col-12 ">
              <template v-if="this.hasRootCategories">

                  <span :data-value="0" class="btn btn-primary" v-bind:class="{'btn-success':((data.parent_id==0)),'btn-secondary':(data.parent_id!==0)}" v-on:click="onClickElementCategory(0)">
                      <template v-if="Number(data.parent_id)===0">
                          <i class="fa fa-folder"></i>
                      </template>
                      <template v-if="Number(data.parent_id)!==0">
                          <i class="fa fa-folder-open"></i>
                      </template>
                  </span>

              </template>

              <!--{{$t('selproductcategory.topcategory')}}-->
              <template v-if="Array.isArray(this.elementCategoryIds) &&this.elementCategoryIds.length>0">

                  <template v-for="(id, i) in Array.from(this.elementCategoryIds).reverse()">
                      <span class="font-weight-bold"> > </span> <span :data-value="id" class="btn btn-primaryX"
                                                                      v-bind:class="{'btn-success':((data.parent_id==id)),'btn-secondary':(data.parent_id!==id)}"
                                                                      v-on:click="onClickElementCategory(id)">{{(getElementCategoryById(id)).name}}</span>
                  </template>
              </template>
          </div>
      </div>

    <template v-if="Array.isArray(this.elementCategoryChildren) &&this.elementCategoryChildren.length>0">
        <template v-for="(id, i) in this.elementCategoryChildren">
            <!--<template v-if="Number(id)!==Number(data.id)">-->
              <div class="colX">
                <label :class="' box box-x btn-box elementType-category '+ ' ' + boxExtraClass" v-on:click="function(e){onClickElementCategory(id,e)}">
                  <span :class="'iconDefault ' + (getElementCategoryById(id)).iconclass "
                        :style="'background-color:' + (getElementCategoryById(id)).iconbgcolor + '; color:' + (getElementCategoryById(id)).iconfgcolor + ';'"></span><span
                        class="textLabel">{{(getElementCategoryById(id)).name}}
                </span>
                </label>

              </div>
            <!--</template>-->
        </template>
    </template>



    <template v-for="row in elements">

      <div class="colX" v-if="Number(row.pack) === 1">
        <label :for="'text-input' + row.id " :class="' box box-x btn-box elementPack-' + row.pack + ' ' + boxExtraClass">
          <span :class="'iconDefault ' + row.iconclass " :style="'background-color:' + row.iconbgcolor + '; color:' + row.iconfgcolor + ';'"></span><span class="textLabel">{{row.name}}</span>
        </label>
        <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value', 'type']" hasToKeyboard :id="'text-input' + row.id " :data-id="row.id"
                   :value="actElCount" :title="row.name" :title2="$t('ProductSearcherMass.priceset')" placeholder="" dataLayout="ndbplus" v-model="xactElCount" inputid="priceset" :afterAccept="afterAccept" :handleOtherKeyFn="handleOtherKeyFn"/>
        <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value', 'type']" hasToKeyboard :id="'text-input_numb' + row.id " :data-id="row.id"
                   :value="actElCount" :title="row.name" :title2="$t('ProductSearcherMass.multiplier')" placeholder="" dataLayout="nplus" v-model="xactElCount_numb"/>

      </div>





      <div class="colX" v-if="Number(row.pack) >= 2 && Number(row.pack) <= 7">
        <div :class="' box box-x btn-box elementPack-' + row.pack + ' ' + boxExtraClass">
        <label :for="'text-input' + row.id " :class="'d-table-cell'">
            <!--:class="' box box-x btn-box elementType-' + row.type "-->
          <span v-if="row.iconclass" :class="'iconDefault ' + row.iconclass " :style="'background-color:' + row.iconbgcolor + '; color:' + row.iconfgcolor + ';'"></span>
          <span v-if="!row.iconclass" style="width: 40px; height: 49px; display: block; background-color: transparent; text-align: center; padding: 6px 0;border-right: 1px solid #ccc; font-size:22px;'"><i
                  class="fa fa-keyboard-o"></i></span>
        </label>

           <span class="textLabel" v-on:click="addPurcaseElement({id:'text-input'+row.id, value:'1' })">{{row.name}}
            <span class="count">{{row.count}} <small class="" v-if="!!row.count">{{$t('global.piece')}}</small></span><span class="price"><small class="">{{prefix}}</small>{{Helper.getFormattedPrice(row.default_price)}}<small
                       class="">
                <template class="" v-if="Number(row.pack)!==2&&Number(row.pack)!==3&&Number(row.pack)!==4&&Number(row.pack)!==5&&Number(row.pack)!==6&&Number(row.pack)!==7">{{suffix}}</template>
                <template class="" v-if="Number(row.pack)===2">{{suffix}}/{{$t('global.pc')}}</template>
                <template class="" v-if="Number(row.pack)===3">{{suffix}}/{{$t('global.kg')}}</template>
                <template class="" v-if="Number(row.pack)===4">{{suffix}}/{{$t('global.l')}}</template>
                <template class="" v-if="Number(row.pack)===5">{{suffix}}/{{$t('global.m')}}</template>
                <template class="" v-if="Number(row.pack)===6">{{suffix}}/{{$t('global.pack')}}</template>
                <template class="" v-if="Number(row.pack)===7">{{suffix}}/{{$t('global.occasion')}}</template>
            </small>
            </span>
        </span>

       </div>
          <InputText className="d-none-hk" isAccept="true" isChange="false" :keys="['id', 'value']" hasToKeyboard :id="'text-input' + row.id " :data-id="row.id"
                     :value="actElCount" :title="row.name" :title2="getTextForElement(row)" placeholder="" dataLayout="n" v-model="xactElCount"/>
      </div>

    </template>


  </span>
</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
    import InputText from '@/components/InputText.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Api from '@/api/Api';

    export default {
        name: 'ProductSearcherMass',
        data() {
            const modul = this;
            return {
                category_sync_pk: null,
                elementCategoryIds: [],
                elementCategories: [],
                elementCategoryChildren: [],
                hasRootCategories: false,
                cachedPrice: "",

                prefix: "",
                suffix: "",
                data: {},
                actElCount: "",
                elements: [],
                Helper: Helper,
                AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    msgPre: "",
                    msgPost: "",
                    delay: 2000,
                },
                boxExtraClass:""
            };
        },
        computed: {
            xactElCount: {
                get(){
                    //this function will determine what is displayed in the input
                    return this.actElCount;
                },
                set(newVal){
                    const modul = this;
                    //this function will run whenever the input changes
                    console.log(newVal);
                    // nplus dbplus handleInput accept
                    let minProductPrice = localStorage.getItem("minProductPrice");
                    if (minProductPrice === null || minProductPrice === void 0) {
                        localStorage.setItem("minProductPrice", "0");
                        minProductPrice = "0";
                    }
                    const NNumber= function (num) {
                        let retNum = 0;
                        try {
                            retNum = Number(num);
                        } catch (e) {
                            retNum = 0;
                        }
                        return retNum;
                    };

                    minProductPrice = NNumber(minProductPrice);
                    if (newVal && newVal.type && newVal.type === "dbplus") {
                        if (newVal.value && newVal.inputid && newVal.inputid === "priceset" && Math.abs(Number(newVal.value)) < minProductPrice) {
                            modul.AlertInPage.msg = "ProductSearcherMass.alertMinProductPrice";
                            modul.AlertInPage.type = "danger";
                            setTimeout(function (e) {
                                modul.AlertInPage.msg = "";
                            }, Number(3000));
                        } else {
                            modul.cachedPrice = newVal.value;
                            modul.openNumb(newVal);
                        }
                    } else {
                        if (newVal.value && newVal.inputid && newVal.inputid === "priceset" && Math.abs(Number(newVal.value)) < minProductPrice) {
                            modul.AlertInPage.msg = "ProductSearcherMass.alertMinProductPrice";
                            modul.AlertInPage.type = "danger";
                            setTimeout(function (e) {
                                modul.AlertInPage.msg = "";
                            }, Number(3000));
                        } else {
                            modul.addPurcaseElement(newVal);
                        }
                    }
                }
            }
            , xactElCount_numb: {
                get(){
                    //this function will determine what is displayed in the input
                    return this.actElCount;
                },
                set(newVal){
                    const modul = this;
                    //this function will run whenever the input changes
                    console.log(newVal);
                    // nplus dbplus handleInput accept
                    newVal.itemPrice = modul.cachedPrice;
//                    newVal.itemSumPrice=modul.cachedPrice;
                    newVal.itemCountnum = newVal.value;
                    if (newVal && newVal.type && newVal.type === "dbplus") {

                    } else {
                        modul.addPurcaseElement(newVal);
                    }
                    modul.cachedPrice = "";
                }
            }
        },
        props: {},
        watch: {
            elements: function (newData, oldData) {
            },
            data: function (newData, oldData) {
                console.log(newData);
            },
            elementCategories: function (newdata, olddata) {
                this.makeDataArrays();
                this.fillHasRootCategories();
            },
            'category_sync_pk': function (newdata, olddata) {
                const modul = this;
//                this.getElements(function (err, res) {
//                    if (!err) {
//                        modul.elements = res;
//                    }
//                });
              modul.elements=[];
              modul.AlertInPage.msg = "form.in_progress";
              modul.AlertInPage.type = "warning";

                this.getElementsByCategorySyncPk(function (err, res) {
                  modul.AlertInPage.msg = "";
                    if (!err) {
                        window.res=res;
                        window.Helper=Helper;
                        let arr=Helper.sortObjectOfArrayByKeyWithLocale(res,"name", Helper.getLang() );
                        const additionalParams = { numeric: true, sensitivity: 'base'};
                        arr=Helper.sortObjectOfArrayByKeyWithLocale(arr,"priority",Helper.getLang(),additionalParams, "desc");
                        modul.elements = arr;
                    }
                }, modul.category_sync_pk);
                this.makeDataArrays();
            },

        },
        mounted() {
            const modul = this;
            console.log("BasketDisplayer");
            modul.prefix = Helper.getMoneyDefaultDisplayPrefix();
            modul.suffix = Helper.getMoneyDefaultDisplaySuffix();

            let boxExtraClass = localStorage.getItem("boxExtraClass");
            if (boxExtraClass === null || boxExtraClass === void 0) {
                localStorage.setItem("boxExtraClass", "");
                modul.boxExtraClass = "";
            }
            modul.boxExtraClass = boxExtraClass;

//            this.getElements(function (err, res) {
//                if (!err) {
//                    modul.elements = res;
//                }
//            });
            this.getElementsByCategorySyncPk(function (err, res) {
                if (!err) {
                    window.res=res;
                    window.Helper=Helper;
                    let arr=Helper.sortObjectOfArrayByKeyWithLocale(res,"name", Helper.getLang() );
                    const additionalParams = { numeric: true, sensitivity: 'base'};
                    arr=Helper.sortObjectOfArrayByKeyWithLocale(arr,"priority",Helper.getLang(),additionalParams, "desc");
                    modul.elements = arr;
                }
            }, modul.category_sync_pk);
            modul.$eventBus.$on('globalResetCategoriesChooser', this.globalResetCategoriesChooserEventHandler);
            modul.category_sync_pk = null;
            modul.getElementCategories();
            modul.fillHasRootCategories();
            modul.data.parent_id = 0;
        },
        beforeDestroy() {
            this.$eventBus.$off('globalResetCategoriesChooser');
        },
        methods: {
            afterAccept: function (obj) {
//                console.log("afterAccept");
//                console.log(obj);
//                console.log(this);
                obj.val="";
            },
            handleOtherKeyFn: function (modulFrom,obj) {
              const modul = this;
//                console.log("handleOtherKeyFn");
//                console.log(obj);
//                console.log(this);
//              {type: "handleOtherKey", value: this.val, id: this.id, inputid: this._props.inputid}
                if(obj && obj.value && obj.value.slice(-1)==="*"){
//                  console.log("handleOtherKeyFn --- :");
//                  console.log(obj.value.slice(-1));
                  const clonedObj= Object.assign({}, obj)
                  const value = obj.value.substring(0, obj.value.length-1)
                  clonedObj.value=value
                  modul.cachedPrice = value;
//                  console.log(clonedObj)
                  modulFrom.hide();
                  modul.openNumb(clonedObj)
                }
//                obj.val="";
            },
            openNumb: function (newVal) {
                const modul = this;
                const itemKey = Number(newVal.id.replace("text-input", ""));
//                setTimeout(function (e) {
//                    modul.actElCount = "";
                    const el = document.querySelectorAll("#text-input_numb" + itemKey)[0];
                    if (el) {
                    setTimeout(function (e) {
                        el.focus();
                    }, 0)
                    }
//                }, 0)
//                console.log(newVal);
            },
            getTextForElement: function (row) {
                const modul = this;
                let retText = "";
                if (row && Number(row.pack) === 2) {
                    retText = " (" + modul.$t('global.pc') + ")"
                }
                if (row && Number(row.pack) === 3) {
                    retText = " (" + modul.$t('global.kg') + ")"
                }
                if (row && Number(row.pack) === 4) {
                    retText = " (" + modul.$t('global.l') + ")"
                }
                if (row && Number(row.pack) === 5) {
                    retText = " (" + modul.$t('global.m') + ")"
                }
                if (row && Number(row.pack) === 6) {
                    retText = " (" + modul.$t('global.pack') + ")"
                }
                if (row && Number(row.pack) === 7) {
                    retText = " (" + modul.$t('global.occasion') + ")"
                }
                return retText;
            },
            addPurcaseElement: function (newVal) {
                const modul = this;
                console.log("addPurcaseElement")
                if (newVal.value && !isNaN(Number(newVal.value)) && Number(newVal.value) !== 0) {
                    this.actElCount = newVal.value;
                    const itemKey = Number(newVal.id.replace("text-input", "").replace("_numb", ""));
                    /*                    Wexford
                     itemPrice
                     itemCountnum*/
                    modul.getElementById(function (err, row) {
//                        if (rows && rows.length === 1) {
                            console.log(row);
                            let itemValue = Number(newVal.value);
                            if (row) {
                                const dbElement = row;
                                const pack = Number(dbElement.pack);
                                if (pack === 2 || pack === 6 || pack === 7) { // int
                                    itemValue = Helper.getRoundedNumber(itemValue, 0) // int
                                } else if (pack === 1 || pack === 3 || pack === 4 || pack === 5) {
                                    itemValue = Helper.getRoundedNumber(itemValue, 3) // double
                                }
//                                const itemVat = Number(dbElement.vat);
                                let itemPrice = "";
                                let itemSumPrice = "";
                                let itemCountnum = "";
                                if (newVal.itemPrice && newVal.itemCountnum) {
                                    itemPrice = Number(newVal.itemPrice);
                                    itemCountnum = Number(newVal.itemCountnum);
                                    itemSumPrice = Number(newVal.itemPrice) * Number(newVal.itemCountnum);
                                } else if (pack === 1) {
                                    itemPrice = Number(itemValue);
                                    itemSumPrice = Number(itemValue);
                                    itemCountnum = 1;
                                } else {
                                    itemPrice = Number(dbElement.default_price);
                                    itemCountnum = itemValue;
                                    itemSumPrice = Number(itemValue) * Number(dbElement.default_price);
                                }
                                modul.cachedPrice = "";
                                //                            // termék listához
                                if (itemValue !== 0) {
                                    try {
                                        const element = {itemKey: itemKey, itemValue: itemValue, itemPrice: itemPrice, itemCountnum: itemCountnum, itemSumPrice: itemSumPrice}; // , itemVat: itemVat
                                        modul.$eventBus.$emit('globalAddPurcaseElement', element);
                                    }
                                    catch (err) {
                                        console.log("catched error - globalAddPurcaseElement");
                                    }
                                }
                            }
//                        }
                    }, Number(itemKey));
                }
                setTimeout(function (e) {
                    modul.actElCount = "";
                }, 0)
            },

            fillHasRootCategories: function () {
                const modul = this;
                let hasRootCategories = false;
                if (Array.isArray(modul.elementCategories)) {
                    Array.prototype.forEach.call(modul.elementCategories, function (e, x) {
                        if (Number(e.parent_id) === 0) {
                            hasRootCategories = true;
                        }
                    })
                }
                modul.hasRootCategories = hasRootCategories;
            },
            globalResetCategoriesChooserEventHandler: function () {
                const modul = this;
                modul.onClickElementCategory(0);
                modul.fillHasRootCategories(0);
            },
            getElementCategories: function () {
                const modul = this;
                const cb = function (err, res) {
                  modul.elementCategories = res;
                }
                Api.getElementCategories({}).then(function (e) {
                  if (e && e.result === true) {
                    console.log(e)
                    cb(null,e.data);
                  }
                },function (err) {
                  console.log(err)
                  cb(err,null);
                });
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && Array.isArray(arrRes)) {
//                            let arrResCopied = arrRes;
////                            Helper.sortObjectOfArrayByKey(arrResCopied, "name");
////                            Helper.sortObjectOfArrayByKey(arrResCopied, "priority");
//                            modul.elementCategories = arrResCopied;
//                        }
////                        cb(err, arrRes)
//                    }
//                    , "element_category", "*", "(`deleted` = 0 OR `deleted` = '0')", "CAST(priority AS int) desc, CAST(name AS int) asc");
            },

            makeDataArrays(){
                const modul = this;
                const elementCategoryChildren = [];
//                // model feltölése
//                modul.data.parent_sync_pk=null;
//                Array.prototype.forEach.call(modul.elementCategories, function (e, i) {
//                    if (Number(e.id) === Number(modul.category_sync_pk)) {
//                        modul.parent_sync_pk = e.parent_sync_pk;
//                    }
//                });
                // alkategóriák listájának feltöltése
                Array.prototype.forEach.call(modul.elementCategories, function (e, i) {
                    if (e.parent_sync_pk === modul.category_sync_pk || ( e.parent_sync_pk === "" && modul.category_sync_pk === null )) {
                        elementCategoryChildren.push(e.id);
                    }
                });
                modul.elementCategoryChildren = elementCategoryChildren;
                // alkategóriák listájának feltöltése
                modul.makeElementCategoryIds();
            },
            makeElementCategoryIds(){
                const modul = this;
                const elementCategoryIds = [];
                const parentCategoryAdder = function (parent_sync_pk) {

                    Array.prototype.forEach.call(modul.elementCategories, function (e, i) {
                        if ((e.sync_pk) === (parent_sync_pk) && Number(e.deleted) !== 1) {
                            elementCategoryIds.push(e.id);
                            parentCategoryAdder(e.parent_sync_pk);
                        }
                    });

                }
                parentCategoryAdder(modul.category_sync_pk);
                modul.elementCategoryIds = elementCategoryIds;
            },

            onClickElementCategory(id, e){
                if (e && e.preventDefault) {
                    e.preventDefault();
                }
                const modul = this;
                console.log("klikk")
                modul.data.parent_id = id;
                const elementCategory = modul.getElementCategoryById(id)
                if (elementCategory.sync_pk) {
                    modul.category_sync_pk = elementCategory.sync_pk;
                } else {
                    modul.category_sync_pk = null;
                }
                this.makeDataArrays();

            },
            getElementCategoryById(id){
                const modul = this;
                if (Array.isArray(modul.elementCategories)) {
                    let ret = 0;
                    modul.elementCategories.forEach(function (elementCategory) {
                        if (Number(id) === Number(elementCategory.id)) {
                            ret = Object.assign({}, elementCategory);
                        }
                    });
                    return ret;
                }
            },

//            clicktofn(e){
////                console.log("clicktofn");
////                const modul = this;
////                e.preventDefault();
////                console.log("clicktofn clicked");
//            },

// Elvileg nem kell
//            getSell: function (cb, id) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell left join buyer on buyer.id = sell.id_buyer", "*, concat(pre_name, ' ',first_name, ' ',last_name) buyertext, sell.id id", "sell.id=" + id);
//            },
//            getLastSellId: function (cb, id) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "sell ", "id", "1", "id desc", "1");
//            },



//            getElementTypes: function (cb) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    // TODO left join for stock
//                    , "element ", "type", "(`deleted` = 0 OR `deleted` = '0') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1') group by type");
//            },
//            getElementCategories: function (cb, id) {
//                const model = this;
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
//                                Array.prototype.forEach.call(arrRes, function (e, i) {
//                                    // TODO - need filter by id, and drop the previeusly
//                                    model.cachedCategories.push(e);
//                                })
//                            }
//                        }
//                        cb(err, arrRes)
//
//                    }
//                    , "element_category", "*", "deleted = 0 and parent_id=" + id, " name asc");
//            },
//            getElementByCategoryId: function (cb, id, type = null) {
//                const model = this;
//                let stringType = "";
//                if (type !== null) {
//                    stringType = " and type = " + Number(type) + " ";
//                }
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
//                                Array.prototype.forEach.call(arrRes, function (e, i) {
//                                    model.purcaseBarcodeItems.push(e);
//                                })
//                            }
//                        }
//                        cb(err, arrRes)
//                    }
//                    // TODO left join for stock
//                    , "element left join stock on stock.id_element=element.id", "element.*, stock.count count", "deleted = 0 and parent_id=" + id + stringType, " name asc");
//            },

            // --------------------------------

            getElementsByCategorySyncPk: function (cb, category_sync_pk) {
              const modul = this;
              Api.getElementsByCategorySyncPk({id:category_sync_pk}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  modul.$eventBus.$emit('globalAddCachedElements', e.data);
                  cb(null,e.data);
                }
              },function (err) {
                console.log(err)
                cb(err,null);
              });
              /*
                let where = "(`element`.`deleted` = 0 OR `element`.`deleted` = '0') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1')";
                if (typeof category_sync_pk === "string" && category_sync_pk.length > 0) {
                    where += " AND elementcategory_syncpk=" + window.db.quote(category_sync_pk);
                } else {
                    where += " AND ( elementcategory_syncpk='' OR elementcategory_syncpk is null OR elementcategory_syncpk='0' ) ";
                }
                window.db.select(function (err, res) {
                        cb(err, window.db.convertResToArray(err, res))
                    }, "element  left join stock on stock.id_element=element.id AND (`stock`.`deleted` = 0 OR `stock`.`deleted` = '0')", "element.*, `stock`.`count` as `count`",
                    where,
                    "CAST(priority AS int) desc, LOWER(name) asc", "800");
                */
            },

            /**
             * Amikor üres formból indulunk ki - elements lekérdezés
             * @param cb
             */
//            getElements: function (cb) {
//                window.db.select(function (err, res) {
//                    cb(err, window.db.convertResToArray(err, res))
//                }, "element", "*", "(`deleted` = 0 OR `deleted` = '0') AND (`type` = 1 OR `type` = '1') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1')", "CAST(priority AS int) desc, CAST(name AS int)  asc", "800");
//            },
            /**
             * Amikor üres formból indulunk ki - elements lekérdezés
             * @param cb
             */
//            getElementsType1: function (cb) {
//                window.db.select(function (err, res) {
//                    cb(err, window.db.convertResToArray(err, res))
//                }, "element", "*", "(`deleted` = 0 OR `deleted` = '0') AND  (`parent_id` = 0 OR `parent_id` = '0') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1')", "CAST(priority AS int) desc, CAST(name AS int)  asc");
//            },

//            purcaseBarcodeItems: [],
            /**
             * For add basket
             */
            getElementById: function (cb, id) {
                const modul = this;

              Api.getElement({id:id}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  modul.$eventBus.$emit('globalAddCachedElements', e.data);
                  cb(null,e.data);
                }
              },function (err) {
                console.log(err)
                cb(err,null);
              });
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
////                        if (arrRes && arrRes[0]) {
////                            if (Array.isArray(arrRes)) {
////                                Array.prototype.forEach.call(arrRes, function (e, i) {
////                                    model.purcaseBarcodeItems.push(e);
////                                })
////                            }
////                        }
//                        cb(err, arrRes)
//                    }
//                    , "element", "*", "id=" + Number(id) + " AND (`deleted` = 0 OR `deleted` = '0') "); //  AND type = 2 // AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1')
            },
//            getElementByBarcode: function (cb, barcode) {
//                const model = this;
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
////                                Array.prototype.forEach.call(arrRes, function (e, i) {
////                                    model.purcaseBarcodeItems.push(e);
////                                })
//                            }
//                        }
//                        cb(err, arrRes)
//                    }
//                    , "element", "*", "barcode=" + window.db.quote(barcode) + " AND (`deleted` = 0 OR `deleted` = '0') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1') AND type = 2");
//            },
//            getElementByText: function (cb, text) {
//                const model = this;
//                window.db.select(
//                    function (err, res) {
//                        let arrRes = window.db.convertResToArray(err, res);
//                        if (arrRes && arrRes[0]) {
//                            if (Array.isArray(arrRes)) {
////                                Array.prototype.forEach.call(arrRes, function (e, i) {
////                                    model.purcaseBarcodeItems.push(e);
////                                })
//                            }
//                        }
//                        cb(err, arrRes)
//                    }
//                    , "element", "*", "name like " + window.db.quote("%" + text + "%") + " AND (`deleted` = 0 OR `deleted` = '0') AND (`element`.`in_sellingbrowse` = 1 OR `element`.`in_sellingbrowse` = '1') AND type = 2");
//            },
//            getElementsByBarcodes: function (cb, barcodes) {
//                const model = this;
//                let strBarcodes = null;
//                if (Array.isArray(barcodes)) {
//                    let arrbk = [];
//                    Array.prototype.forEach.call(barcodes, function () {
//                        arrbk.push(window.db.quote(barcode));
//                    });
//                    strBarcodes = arrbk.join(",");
//                    window.db.select(
//                        function (err, res) {
//                            let arrRes = window.db.convertResToArray(err, res);
////                            if (arrRes && arrRes[0]) {
////                                model.purcaseBarcodeItems.push(arrRes[0]);
////                            }
//                            cb(err, arrRes)
//                        }
//                        , "element", "*", "barcode in (" + strBarcodes + ") AND (`deleted` = 0 OR `deleted` = '0')");
//                } else {
//                    cb(null, []);
//                }
//            },

            // -----------------------------
            /**
             * Hát, ezt át kell hozni
             */
            renderPurcaseItems: function () {

            },


        },
        components: {
            InputText,
            AlertInPage
        },
    };
</script>

<style>

    .d-none-hk {
        width: 1px;
        height: 1px;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
    }

    .vue-touch-keyboard-holder.openKeyboard .d-none-hk {
        width: 100%;
        height: auto;
        opacity: 1;
        position: static;
        /*top: 0;*/
        /*left: 0;*/
    }

</style>

